//Update banner live text on homepage
let banner__headingElements = document.querySelectorAll(".banner__heading, .banner__text");
[].slice.call( banner__headingElements ).forEach(function ( banner__headingelement ) {
  newHTML = banner__headingelement.innerHTML.replaceAll('[','<span class="highlight">');
  newHTML = newHTML.replaceAll(']','</span>');
  banner__headingelement.innerHTML = newHTML;
});

window.titleColorChange = function () {
  $('.title-bundle').each(function () {
    let txt = $(this).text();
    let allText = txt.split(' ');
    let newTitle = '';
    for (let i = 0; i < allText.length; i++) {
      let newTxt = allText[i];
      newTxt = newTxt.trim();
      let className = newTxt;
      if ( newTxt == '+'
          || newTxt == '&'
          || newTxt == 'Capsule'
          || newTxt == 'Serum'
          || newTxt == 'Hair'
          || newTxt == 'Skin'
      ) {
        if(newTxt == '+') className = 'plus';
        newTitle += '<span class="' + className + '"> ' + newTxt + ' </span>';
      }
      else {
        newTitle += '<span class="' + className + '"> ' + newTxt + '</span>';
      }
    }
    $(this).html(newTitle);
  })
}

/* Split Bundle Titles into separate <span> tags to apply Registered character with ::after CSS */
$(document).ready(function () {
  window.titleColorChange();
})

//Create slick sliders for few snippets
$('.js-custom-slider-container').slick({
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});